// Last modified: 2023/01/19 15:58:31
import LongReadController from './LongReadController.vue';
import LongReadTarget from './LongReadTarget.vue';
import LongReadTargetTocLink from './LongReadTargetTocLink.vue';

export { LongReadController, LongReadTarget, LongReadTargetTocLink };
